/* formatApiError (iter451) — safely convert any axios error response to a string.
 *
 * Handles FastAPI 422 validation errors which return:
 *   { detail: [{type, loc, msg, input, ctx, url}, ...] }
 * Rendering these objects directly in React crashes the page.
 */
export function formatApiError(err, fallback = "Възникна грешка") {
  try {
    const d = err?.response?.data;
    if (!d) return err?.message || fallback;
    // FastAPI validation array
    if (Array.isArray(d.detail)) {
      const first = d.detail[0];
      if (first?.msg) return first.msg;
      return fallback;
    }
    // String detail
    if (typeof d.detail === "string") return d.detail;
    // Object detail with message
    if (d.detail?.message) return d.detail.message;
    if (typeof d.message === "string") return d.message;
    if (typeof d === "string") return d;
    return fallback;
  } catch {
    return fallback;
  }
}

export default formatApiError;
